// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"580":"i18n","946":"l10n"}[chunkId] || chunkId) + "." + {"283":"79345140","350":"c3caf410","580":"552262fa","946":"891beb66"}[chunkId] + ".js";
};